export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            有任何问题或合作意向，欢迎通过以下方式联系天美麻花星空影视团队
          </p>
        </div>
        <div className="max-w-lg mx-auto">
          <div className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-300/20 text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/15 mx-auto mb-4">
              <i className="ri-mail-send-line text-primary-400 text-2xl"></i>
            </div>
            <h3 className="text-lg font-heading font-bold text-foreground-100 mb-2">
              投稿与合作咨询
            </h3>
            <p className="text-sm text-foreground-500 mb-5 leading-relaxed">
              影视资源推荐、版权合作、广告投放或任何问题反馈，请发送邮件至以下地址，我们将在24小时内回复。
            </p>
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500/10 border border-primary-500/20">
              <span className="text-sm font-medium text-primary-400">contact@tianmeimahua.vip</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-file-copy-line text-primary-400 text-sm cursor-pointer"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}